import { loadData } from '../../queries/__mocked_data__/time-based-metrics';
import { DownloadRawDataMutation } from '../download-raw-data';

// Helper function to convert data array to CSV string
function convertToCsv(data: Awaited<typeof loadData>): string {
  if (data.length === 0) {
    return '';
  }

  // Get headers from the first object
  const headers = Object.keys(data[0]);
  const csvHeaders = headers.join(',');

  // Convert data rows to CSV format
  const csvRows = data.map((row) => {
    return headers
      .map((header) => {
        const value = row[header as keyof typeof row];
        // Escape commas and quotes in values
        if (
          typeof value === 'string' &&
          (value.includes(',') || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      })
      .join(',');
  });

  return [csvHeaders, ...csvRows].join('\n');
}

export async function downloadRawDataMocked(
  input: DownloadRawDataMutation.Input,
): Promise<DownloadRawDataMutation.Output> {
  try {
    // Load the data from time-based-metrics
    const data = await loadData;

    // Filter by systemId (accure_id) and groupId (description_id)
    const filteredData = data.filter((row) => {
      const matchesSystemId = row.accure_id === input.systemId;
      const matchesGroupId =
        row.description_id.toLowerCase() === input.groupId.toLowerCase();
      return matchesSystemId && matchesGroupId;
    });

    // Convert filtered data to CSV
    const csvContent = convertToCsv(filteredData);

    // Create Blob with CSV content
    const file = new Blob([csvContent], { type: 'text/csv' });

    return {
      file,
    };
  } catch (error) {
    console.error('Error generating CSV:', error);
    // Return empty CSV on error
    const file = new Blob([''], { type: 'text/csv' });
    return { file };
  }
}
